import { Button, Card, Space, Tabs, TabsProps } from "antd";
import { InboundRemittanceProvider } from "../../../context/InboundRemittanceTableContext";
import { RemittanceTable } from "../remittanceTable/RemittanceTable";
import { InboundRemittance, RemittanceType } from "../../../types/reconciliation";
import React, { useMemo, useState } from "react";
import { CreateStandardRemittanceModalButton } from "./CreateStandardRemittanceModalButton";
import { CreateArchivedRemittanceModalButton } from "./CreateArchivedRemittanceModalButton";
import StatementTitlesTable from "../statementTitlesTable/StatementTitlesTable";
import { StatementTitlesTableProvider } from "../../../context/StatementTitlesTableContext";
import { LeftOutlined } from "@ant-design/icons";

export const NewRemittanceCard = () => {

  const [activeKey, setActiveKey] = useState<RemittanceType>(RemittanceType.standard);
  const [selectedRecord, setSelectedRecord] = useState<InboundRemittance>();


  const items: TabsProps["items"] = [
    {
      key: RemittanceType.standard,
      label: "Ordinarie",
      children: (
        <>
          <InboundRemittanceProvider>
            <RemittanceTable
              defaultFilters={{ remittance_type: RemittanceType.standard }}
              onRecordDetailClick={(record) => {
                setSelectedRecord(record);
              }} />
          </InboundRemittanceProvider>
        </>)
    },
    {
      key: RemittanceType.archived,
      label: "Archiviate",
      children: (
        <>
          <InboundRemittanceProvider>
            <RemittanceTable
              defaultFilters={{ remittance_type: RemittanceType.archived }}
              onRecordDetailClick={(record) => {
                setSelectedRecord(record);
              }} />
          </InboundRemittanceProvider>
        </>
      )
    }
  ];

  const extraContent = useMemo(() => {
    switch (activeKey) {
      case RemittanceType.standard:
        return <CreateStandardRemittanceModalButton />;
      case RemittanceType.archived:
        return <CreateArchivedRemittanceModalButton />;
    }
  }, [activeKey]);

  return (
    <Card
      title={<>
        {selectedRecord &&
        <Space direction={"vertical"}>
          <Button
            type={"link"}
            style={{padding: 0}}
            onClick={() => setSelectedRecord(undefined)}
            icon={<LeftOutlined />}>
            Torna indietro
          </Button>
          {`Dettaglio di: ${selectedRecord.name}`}
      </Space>}
        {!selectedRecord && "Rimesse"}
      </>
      }>
      {!selectedRecord && <Tabs
        activeKey={activeKey}
        onChange={(key) => {
          setActiveKey(key as RemittanceType);
        }}
        items={items}
        type={"card"}
        tabBarExtraContent={extraContent} />}
      {selectedRecord && (
        <StatementTitlesTableProvider>
          <StatementTitlesTable
            defaultFilters={{ remittance_uuid: selectedRecord.uuid }}
            useStatementsTitlesGroup={activeKey === RemittanceType.standard } />
        </StatementTitlesTableProvider>
      )}
    </Card>
  );
};